<!-- title -->
<app-modal-title
  [title]="'common.pollParserLottery' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<form [formGroup]="form" autocomplete="off">
  <div mat-dialog-content class="dialog-content tw-text-xl tw-text-center mb-1">
    <div>
      <div
        class="alert alert-primary winner-list tw-text-right tw-mb-5 tw-pb-3"
        style="font-size: 14px !important"
      >
        <div
          [innerHtml]="'messages.lotteryAlert' | translate"
          style="width: 377px"
        ></div>
      </div>

      <!--count-->
      <div class="row">
        <app-search-input-lottery
          [value]="count"
          (value)="count = $event"
          controlName="count"
          (onSubmit)="onConfirm()"
          [searchLoading]="loading"
        ></app-search-input-lottery>
      </div>

      <!--pollParserFormula-->
      <div
        *ngIf="pollParserFormula.length > 0"
        class="row tw-w-[400px] tw-mt-[20px]"
      >
        <div
          class="tw-w-1/2 tw-flex"
          *ngFor="let item of pollParserFormula; let i = index"
        >
          <mat-slide-toggle
            [checked]="isChecked[i]"
            (change)="changePollParserFormula(item.keyword, i)"
          >
            <app-expand-text [placement]="'right'">
              <span small-text>
                <span>
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item.isCorrect"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item.isCorrect"
                  ></i>
                </span>
                {{ item.keyword }}
              </span>
              <div full-text class="full-text-display">
                <span>
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item.isCorrect"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item.isCorrect"
                  ></i>
                </span>
                {{ item.keyword }}
              </div>
            </app-expand-text>
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <!-- winner list -->

    <div>
      <fieldset class="tw-h-full tw-mt-[20px] tw-w-[400px]">
        <legend class="tw-flex-center">
          <span>
            {{ "common.winnerList" | translate }}
          </span>
        </legend>

        <div *ngIf="!isShowWinner && isParticipants" class="lottery-text">
          {{ "messages.lotteryNotStart" | translate }}
        </div>

        <div
          *ngIf="isNumberOfWinnersLessThanNumberOfParticipants"
          class="alert alert-danger number-of-winners"
        >
          <div>
            {{
              "messages.numberOfWinnersLessThanNumberOfParticipants" | translate
            }}
          </div>
        </div>

        <div
          *ngIf="!isParticipants"
          class="alert alert-danger number-of-winners"
        >
          <div>
            {{ "messages.numberOfParticipants" | translate }}
          </div>
        </div>

        <div *ngIf="isShowWinner" class="show-winner-table">
          <table class="tw-bg-gray-200 border-white table-bordered tw-w-full">
            <thead class="tw-bg-gray-800 tw-fs-[16px text-white">
              <tr class="tw-mr-3">
                <th scope="col" class="tw-w-1/5 tw-text-center p-3"></th>
                <th
                  scope="col"
                  class="w-80 tw-text-center p-3"
                  style="font-size: 13px"
                >
                  {{ "common.mobile" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let pollParserLotteryValue of pollParserLotteryValues;
                  let i = index
                "
                class="tw-mr-3"
              >
                <td class="tw-text-center tw-p-3 tw-text-[1.2rem]">
                  {{ i + 1 }}
                </td>
                <td class="tw-text-center tw-p-3 tw-text-[1.2rem]">
                  {{ pollParserLotteryValue }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
    </div>
  </div>
</form>
